"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultValueListener = void 0;
var react_1 = require("react");
var useDefaultValueListener = function (defaultValues, reset, transformValues) {
    var _a = (0, react_1.useState)(undefined), appliedDefaults = _a[0], setAppliedDefaults = _a[1];
    (0, react_1.useEffect)(function () {
        var _a;
        if (JSON.stringify(appliedDefaults) !== JSON.stringify(defaultValues)) {
            setAppliedDefaults(defaultValues);
            reset((_a = transformValues === null || transformValues === void 0 ? void 0 : transformValues(defaultValues)) !== null && _a !== void 0 ? _a : defaultValues);
        }
    }, [reset, defaultValues, appliedDefaults]);
};
exports.useDefaultValueListener = useDefaultValueListener;
